module.exports = "<app-main\n  [datasetTitle]=\"datasetTitle\"\n  [datasetName]=\"datasetName\"\n></app-main>\n"